import { IBoletoDepositoResponse } from '../entities/IBoletoDepositoResponse'
import { IPagamentoRepository } from '../repositories/IPagamentoRepository'

export interface IListaBoletosDeposito {
  execute(frotistaId: number): Promise<IBoletoDepositoResponse[]>
}

export default class ListaBoletosDepositoImpl implements IListaBoletosDeposito {
  constructor(private readonly pagamentosRepository: IPagamentoRepository) {}
  async execute(frotistaId: number): Promise<IBoletoDepositoResponse[]> {
    return this.pagamentosRepository.listaBoletosDeposito(frotistaId)
  }
}
